// extracted by mini-css-extract-plugin
export default {"root":"TopicDefaultIcon-module__root","icon":"TopicDefaultIcon-module__icon","title":"TopicDefaultIcon-module__title"};